import { Record } from "immutable";

const TeaserRecord = new Record({
  id: undefined,
  cid: undefined,
  title: "",
  desc: "",
  url: "",
  image: "",
  cpc: null,
  image_url: "",
  use_campaign_cpc: true
});

export default class Teaser extends TeaserRecord {}
